export const PATHS_NAME = {
  MAIN: 'infonoise',
  CALENDAR: 'calendar',
  FORECASTERS: 'forecasters',
  FEEDBACK: 'report',
  ARTICLES: 'articles',
  SCANNER: 'screener',
  STOREROOM: 'storeroom',
  REDIRECT_ARTICLE: 'redirect_article',
  SIGNALS: 'signals',
  TWITTER_HYPE: 'twitter_hype',
  KNOWLEDGE_BASE: 'knowledge_base',
  RULES: {
    TERMS: 'rules_terms',
    PRIVACY: 'rules_privacy',
  },
  USER: {
    MAIN: 'user_main',
    SETTINGS: 'user_settings',
    COMMENTS: 'user_comments',
    SUBSCRIPTION: 'user_subscription',
    SUBSCRIPTION_PURCHASE: 'user_subscription_purchase',
    SUBSCRIPTION_WALLETS: 'user_subscription_wallets',
    ALPHA: 'user_alpha',
  },
  OTHER_USERS: {
    MAIN: 'other_users_main',
    PROFILE: 'other_user_profile',
    COMMENTS: 'other_user_comments',
    ALPHA: 'other_user_alpha',
  },
  GOOGLE_LOGIN: 'google_login',
  GOOGLE_LINK: 'google_link',
  TELEGRAM_LOGIN: 'telegram_login',
  TELEGRAM_LINK: 'telegram_link',
  CONFIRM_EMAIL: 'confirm_email',
  PENDING_CONFIRM_EMAIL: 'pending_confirm_email',
  RESET_PASS: 'reset_pass'
}
